import { DefaultTheme } from './theme';

export class IkeCssUtil {
	static absolute(top: number, left: number) {
		return { position: 'absolute', top: DefaultTheme.space(top), left: DefaultTheme.space(left) };
	}

	static padding(up: number): { padding: string };
	static padding(updown: number, leftRight: number): { padding: string };
	static padding(up: number, right?: number, down?: number, left?: number) {
		if (right == null) {
			return { padding: DefaultTheme.space(up) };
		}
		if (down == null) {
			return { padding: `${DefaultTheme.space(up)} ${DefaultTheme.space(right)}` };
		}
		return {
			padding: `${DefaultTheme.space(up)} ${DefaultTheme.space(right)} ${DefaultTheme.space(down)} ${DefaultTheme.space(left)}`,
		};
	}

	static Font = {
		familyCondensed: {
			'font-family': DefaultTheme.font.familyCondensed,
		},
	};

	static Flex = {
		column: {
			display: 'flex',
			'flex-direction': 'column',
		},
		center: {
			display: 'flex',
			'justify-content': 'center',
			'align-items': 'center',
		},
		centerVertical: {
			display: 'flex',
			'align-items': 'center',
		},
	};
}
